import { useEscapeById, useModal } from 'shared/lib/modal';
import { usePaginationFilter } from 'shared/lib/pagination';
import { ModalCard } from 'shared/ui/cards/modalCard';
import { ButtonContained } from 'shared/ui/buttons/buttonContained';
import { Flex } from 'shared/ui/flex';
import { ButtonOutlined } from 'shared/ui/buttons/buttonOutlined';
import { FC, ReactNode } from 'react';
import { ButtonsContainer } from './styles';
import { PaginationHook } from 'shared/lib/pagination';
import { Filter } from 'entities/orders';

interface OrderFilterCardProps {
	reset: () => void;
	children: ReactNode;
	defaultFilters?: { [key: string]: any };
}

export const FilterCard: FC<OrderFilterCardProps> = ({
	children,
	defaultFilters,
	reset,
}) => {
	const { fetchDataWithDispatch, filters, resetFilters } =
		usePaginationFilter() as PaginationHook;
	const { closeModal } = useModal();

	const getByFilter = () => {
		fetchDataWithDispatch();
		closeModal();
	};

	const resetHandler = () => {
		reset();
		closeModal();

		let newFilters: Filter = {};

		if (filters.dt_start__gte) {
			newFilters.dt_start__gte = filters.dt_start__gte;
		}

		if (filters.dt_end__lte) {
			newFilters.dt_end__lte = filters.dt_end__lte;
		}

		if (defaultFilters) {
			newFilters = { ...newFilters, ...defaultFilters };
		}

		resetFilters({ newFilters });
	};

	useEscapeById('filter-modal');

	return (
		<ModalCard headerContent={'Фильтры'} onClose={closeModal} id="filter-modal">
			{children}
			<ButtonsContainer>
				<Flex $justify="center" $direction="column" $gap="10px">
					<ButtonContained onClick={getByFilter}>
						Применить
					</ButtonContained>
					<ButtonOutlined onClick={resetHandler}>
						Сбросить
					</ButtonOutlined>
				</Flex>
			</ButtonsContainer>
		</ModalCard>
	);
};
